import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';

import img from './img.png';

function Comment() {
  return (
        <Container spacing={32}
                   fullWidth
                   align='center'>
            <GiftImage src={img}
                       width={224}
                       height={112} />
            <Text size='4xl' fontWeight='bold'>
                선물을 보냈어요!
            </Text>
        </Container>
  );
}

const Container = styled(Column)`
    padding: 48px 0 42px 0
`;

const GiftImage = styled(Image)`
    margin-left: 30px;
`;

export default Comment;
